<template>
	<div class="site-content">
		<div class="not-found">
			<img src="../img/toy-horse.svg" class="not-found__img" alt="404">
			<h1 class="not-found__title">
				404
			</h1>
			<h2 class="not-found__text">
				<span v-html="t('page.404.text')"></span>
			</h2>
			<div class="container">
				<div class="row mt-4 align-items-center justify-content-center">
					<div class="col-6 d-flex justify-content-center" v-if="from">
						<router-link :to="from.fullPath" class="btn btn-link">{{t('page.404.btn.go-back')}}</router-link>
					</div>

					<div class="col-6" v-if="to && to.redirectedFrom">
						{{t('page.404.you-enter')}}
						<b>{{to.redirectedFrom}}</b>
					</div>
				</div>
			</div>
		</div>
		<span class="not-found__tgt">
			<a href="https://de.wikipedia.org/wiki/42_(Antwort)" target="_blank">Universal answer: 42!</a>
		</span>
	</div>
</template>
<script>
	export default {
		name: 'NotFound',
		beforeRouteEnter( to, from, next){
			next(vm => {
				vm.setInfo(from, to);
			})
		},
		data() {
			return {
				from: null,
				to: null
			}
		},
		mounted() {

		},
		methods: {
			setInfo(from, to){
				this.$set(this, 'from', from);
				this.$set(this, 'to', to);
			}
		}
	}
</script>
<style lang="scss">
	.not-found {
		min-height: 40vh;
		width: 100%;
		display: flex;
		flex-flow: column wrap;
		align-items: center;
		justify-content: center;
		/*font-size: 280px;
		font-weight: 700;*/

		&__title{
			font-size: 50px;
			margin-bottom: 40px;
			font-weight: bold;
		}
		&__img{
			width: 250px;
			max-width: 100%;
			margin-bottom: 70px;
			margin-top: 60px;
		}
		&__tgt {
			float: right;
			margin-right: 20px;
		}
	}
</style>